// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NmZ0q","title":"styles_title__gv__Y"};